class Timeline {
  constructor() {
    // Desktop elements
    this.desktopContainer = document.querySelector(".timeline__inner-desktop");
    this.imagesContainer = document.querySelector(".timeline__images");
    this.timelineInner = document.querySelector(".timeline__inner-desktop");
    this.images = document.querySelectorAll(".timeline__image");
    this.contentContainer = document.querySelectorAll(
      ".timeline__content-progress-wrapper-inner"
    );

    // Mobile elements
    this.mobileTrack = document.querySelector(".timeline__mobile-track");
    this.mobileSlides = document.querySelectorAll(".timeline__mobile-slide");
    this.mobileProgressLine = document.querySelector(
      ".timeline__mobile-progress-line"
    );
    this.mobileDots = document.querySelectorAll(
      ".timeline__mobile-progress-dot"
    );

    if (
      (this.imagesContainer && this.timelineInner && this.images.length) ||
      (this.mobileTrack && this.mobileSlides.length)
    ) {
      this.init();
    }
  }

  init() {
    this.setImagesHeight();
    this.setupScrollObserver();
    this.setupMobileSlider();

    // Recalculate on resize
    window.addEventListener("resize", () => {
      this.setImagesHeight();
    });
  }

  setupMobileSlider() {
    if (!this.mobileTrack) return;

    // Update progress on scroll
    this.mobileTrack.addEventListener("scroll", () => {
      requestAnimationFrame(() => this.updateMobileProgress());
    });

    // Initial progress update
    this.updateMobileProgress();
  }

  updateMobileProgress() {
    if (!this.mobileTrack) return;

    // Calculate total scrollable width
    const totalScrollWidth =
      this.mobileTrack.scrollWidth - this.mobileTrack.clientWidth;
    const currentScroll = this.mobileTrack.scrollLeft;

    // Calculate overall progress percentage
    const overallProgress = (currentScroll / totalScrollWidth) * 100;

    this.mobileSlides.forEach((slide, index) => {
      const slideCount = this.mobileSlides.length;

      // Calculate the progress range for this slide (equal ranges)
      const rangePerSlide = 100 / slideCount;
      const slideStartProgress = rangePerSlide * index;
      const slideEndProgress = rangePerSlide * (index + 1);

      // Calculate this slide's progress within its range
      let slideProgress = 0;
      if (overallProgress >= slideStartProgress) {
        slideProgress = Math.min(
          100,
          ((overallProgress - slideStartProgress) / rangePerSlide) * 100
        );
      }

      const progressLine = slide.querySelector(
        ".timeline__mobile-slide-progress-line"
      );
      if (progressLine) {
        progressLine.style.setProperty("--progress", `${slideProgress}%`);
      }

      // Update active state - first slide is always active
      if (index === 0 || slideProgress > 0) {
        slide.classList.add("active");
      } else {
        slide.classList.remove("active");
      }
    });
  }

  setImagesHeight() {
    const windowHeight = window.innerHeight;
    const blocksCount = parseInt(
      this.timelineInner.getAttribute("data-timeline-blocks"),
      10
    );
    const height = windowHeight * blocksCount;

    // Set minimum height to avoid negative values
    const finalHeight = Math.max(height, 300); // 300px as minimum height
    this.desktopContainer.style.height = `${finalHeight}px`;

    // Store section height and block count for scroll observer
    this.sectionHeight = finalHeight;
    this.blocksCount = blocksCount;
  }

  setupScrollObserver() {
    // Create scroll observer
    window.addEventListener("scroll", () => {
      this.handleScroll();
    });
  }

  handleScroll() {
    // Get container position relative to viewport
    const containerRect = this.imagesContainer.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerBottom = containerRect.bottom;

    if (containerBottom <= 0 || containerTop >= window.innerHeight) {
      this.images.forEach((image, index) => {
        image.classList.remove("active");
        this.contentContainer[index].classList.remove("active");
        const progressBar = this.contentContainer[index].querySelector(
          ".timeline__content-progress-progress"
        );
        if (progressBar) {
          progressBar.style.setProperty("--progress", "0%");
        }
      });
      return;
    }

    // Calculate section progress
    const blockHeight = this.sectionHeight / this.blocksCount;
    const scrollPosition = Math.abs(containerTop);
    const currentBlock = Math.floor(scrollPosition / blockHeight);

    // Calculate progress within current block
    const blockProgress = ((scrollPosition % blockHeight) / blockHeight) * 100;

    // Update images visibility and progress bars
    this.images.forEach((image, index) => {
      const imageIndex = parseInt(
        image.getAttribute("data-timeline-image-index"),
        10
      );

      const progressBar = this.contentContainer[index].querySelector(
        ".timeline__content-progress-progress"
      );

      if (imageIndex <= currentBlock) {
        // Fade in current image
        image.classList.add("active");
        this.contentContainer[index].classList.add("active");

        // Set progress for current block
        if (imageIndex === currentBlock) {
          if (progressBar) {
            // Jeśli scrollujemy do góry i jesteśmy w pierwszym bloku, progress powinien być 0
            if (imageIndex === 0 && containerTop > 0) {
              progressBar.style.setProperty("--progress", "0%");
            } else {
              progressBar.style.setProperty("--progress", `${blockProgress}%`);
            }
          }
        } else {
          // Set full progress for previous blocks
          if (progressBar) {
            progressBar.style.setProperty("--progress", "100%");
          }
        }
      } else {
        // Fade out other images
        image.classList.remove("active");
        this.contentContainer[index].classList.remove("active");
        // Reset progress for future blocks
        if (progressBar) {
          progressBar.style.setProperty("--progress", "0%");
        }
      }
    });
  }
}

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", () => {
  new Timeline();
});
